import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTour } from '../context/TourContext';
import MapScreen from '../components/MapScreen';
import TourOverlay from '../components/TourOverlay';
import { SF_TOUR_REPORTS } from '../data/sfTourData';

// Fake guest user — gives MapScreen enough to render without real auth
const TOUR_USER = {
  id: 'tour-guest',
  name: 'Tour Guest',
  email: 'tour@safeher.xyz',
  role: 'user',
  emailVerified: true,
};

export default function TourPage() {
  const { startTour, endTour } = useTour();
  const navigate = useNavigate();

  useEffect(() => {
    startTour();
    return () => endTour();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleLogout = () => {
    endTour();
    navigate('/');
  };

  return (
    <div style={{ position: 'relative', width: '100vw', height: '100vh', overflow: 'hidden' }}>
      {/* Padding for the tour banner at the top */}
      <div style={{ paddingTop: 28, height: '100%', boxSizing: 'border-box' }}>
        <MapScreen
          user={TOUR_USER}
          isTourMode={true}
          tourReports={SF_TOUR_REPORTS}
          onLogout={handleLogout}
          onNavigateToProfile={() => {}}
          onNavigateToReports={() => {}}
          onNavigateToModeratorDashboard={() => {}}
          alertRadius={500}
          locationRefreshInterval={10}
          alertsMuted={true}
          trackingMode={false}
          showAccuracyCircle={false}
          showLocationTrail={false}
          showModeratorCoverageCircle={false}
        />
      </div>
      <TourOverlay />
    </div>
  );
}
